import { useMemo } from 'react';

import { getMatchingOptionsInSortedOrder } from '@lyearn/core/utils/search';
import useDebounceState from '@/hooks/useDebounceState';

import { FilterGroup } from '../../types';

interface UseStaticFilterProps {
  groups: FilterGroup[];
}

function useStaticFilter({ groups: groupsProp }: UseStaticFilterProps) {
  const [searchText, setSearchText, debouncedSearchText] = useDebounceState('');

  const searchProps = useMemo(
    () => ({ value: searchText, onChange: setSearchText }),
    [searchText, setSearchText],
  );

  const groups = useMemo(() => {
    if (!debouncedSearchText) {
      return groupsProp;
    }
    return groupsProp.reduce((filteredGroups, group) => {
      const filteredOptions = getMatchingOptionsInSortedOrder(group.options, debouncedSearchText, {
        keys: ['label'],
      });

      if (filteredOptions.length) {
        filteredGroups.push({ ...group, options: filteredOptions });
      }
      return filteredGroups;
    }, [] as FilterGroup[]);
  }, [debouncedSearchText, groupsProp]);

  return {
    groups,
    searchProps,
  };
}

export default useStaticFilter;
